import React from 'react'

// Components
import LatestPosts from 'components/flex/Posts/Latest/LatestPosts'
import LatestProfessionals from 'components/flex/Posts/Latest/LatestProfessionals'
import LatestStories from 'components/flex/Posts/Latest/LatestStories'

interface LatestShellProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_PostTypes
  location?: any
}

interface PostProps {
  [key: string]: any
}

const LatestShell: React.FC<LatestShellProps> = ({ fields, location = {} }) => {
  const types: PostProps = {
    blog: LatestPosts,
    professionals: LatestProfessionals,
    stories: LatestStories,
  }

  if (!fields.styletype || !types[fields.styletype]) {
    return null
  }

  const Component = types[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default LatestShell
